import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Mutation } from '@apollo/client/react/components';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { CREATE_ORDER_MUTATION } from '../../api/queries/OrderQueries';
import GlobalShortcut from '../GlobalShortcut';
import ToolbarButton from '../toolbar/ToolbarButton';
import { isWithinMenu } from '../common/Menu';
import {
    getDocumentOptions,
    resolveDocumentSelection,
} from '../common/documentOptions';
import MixpanelLogger from '../../diagnostics/logging/mixpanelLogger';
import { KEY_CODES } from 'constant';
import store from 'store';
import { getDefaultTypeForGroup } from '../../../_legacy/models/Datasets';
import { isGroupOnly } from '_legacy/utils/Visibility';
import { parseTankersGroupType } from '../../models/TankersGroupTypes';
import { typesByDataset } from '../../models/Type';

const { KEY_O } = KEY_CODES;

export class AddOrder extends Component {
    constructor(props) {
        super(props);

        // State is used so that the value of the dropdown can be reset
        // each time a value is picked, otherwise the control doesn't always work
        this.state = { dropdownValue: -1 };

        this.handleAddOrder = this.handleAddOrder.bind(this);
        this.isAddOrderKeyPress = this.isAddOrderKeyPress.bind(this);
        this.handleCompleted = this.handleCompleted.bind(this);
    }

    handleAddOrder = (addOrder, groupOnlyType, privacy, isIndividual) => {
        const { groupId, currentGroup } = this.props;
        const defaultTypeFromLayout =
            this.props.selectedLayout.commonSettings.defaultType.currentState;

        const tankersGroupType = parseTankersGroupType(
            currentGroup?.groupSettings?.tankersGroupType
        );
        const availableTypes = typesByDataset(
            currentGroup?.datasetId,
            tankersGroupType
        );
        const isLayoutDefaultTypeAvailable = availableTypes.find(
            (x) => x === defaultTypeFromLayout
        );
        const type = isLayoutDefaultTypeAvailable
            ? defaultTypeFromLayout
            : getDefaultTypeForGroup(currentGroup?.datasetId, tankersGroupType);

        const variables = {
            groupId,
            groupOnly: groupOnlyType !== null,
            groupOnlyType,
            privacy,
            isIndividual,
            type,
        };

        addOrder({
            variables,
        });

        this.setState({
            dropdownValue: -1,
        });
    };

    isAddOrderKeyPress = (event) => {
        if (event.altKey && event.ctrlKey && event.keyCode === KEY_O) {
            event.preventDefault();
            event.stopPropagation();
            return true;
        }
        return false;
    };

    handleCompleted(data) {
        const {
            id,
            visibility,
            privacy,
            groupName,
            isIndividual,
            datasetId,
            groupOnlyType,
        } = data.createOrder;

        this.setState({ dropdownValue: -1 }, () => {
            if (this.props.onCompleted) {
                this.props.onCompleted(data.createOrder);
            }
        });

        MixpanelLogger.trackNewOrderEvent(
            id,
            isGroupOnly(visibility),
            privacy,
            isIndividual,
            groupName,
            'Created',
            datasetId,
            groupOnlyType
        );
    }

    getOptions = () => {
        const currentGroup = store.getState().user.group;
        if (!currentGroup) return [];
        return getDocumentOptions('Order', currentGroup);
    };

    render = () => {
        return (
            <Mutation
                mutation={CREATE_ORDER_MUTATION}
                onCompleted={this.handleCompleted}
                fetchPolicy={'no-cache'}
            >
                {(addOrder, { loading }) => {
                    return (
                        <Fragment>
                            {!this.props.disabled && !loading && (
                                <GlobalShortcut
                                    onMatch={() =>
                                        this.handleAddOrder(
                                            addOrder,
                                            null,
                                            false,
                                            false
                                        )
                                    }
                                    keyMatcher={this.isAddOrderKeyPress}
                                />
                            )}
                            <Dropdown
                                trigger={
                                    <ToolbarButton id="NewOrderButton">
                                        <i className="icons plus-icon" />
                                        New Order
                                    </ToolbarButton>
                                }
                                options={this.getOptions()}
                                onChange={(e, data) => {
                                    /*
                                     * This ensures the user has actually clicked on a menu item as the dropdown onChange
                                     * gets triggered by a blur event. Defect 25602
                                     * Same logic used in AddFixture.jsx
                                     */
                                    if (
                                        isWithinMenu(e.target) ||
                                        ('key' in e && e.key === 'Enter')
                                    ) {
                                        const {
                                            groupOnly,
                                            groupOnlyType,
                                            isIndividual,
                                            privacy,
                                        } = resolveDocumentSelection(
                                            data.value,
                                            this.props.currentGroup?.datasetId
                                        );

                                        this.handleAddOrder(
                                            addOrder,
                                            groupOnly ? groupOnlyType : null,
                                            privacy,
                                            isIndividual
                                        );
                                    }
                                }}
                                value={this.state.dropdownValue}
                                disabled={this.props.disabled || loading}
                            />
                        </Fragment>
                    );
                }}
            </Mutation>
        );
    };
}

AddOrder.propTypes = {
    onCompleted: PropTypes.func,
    disabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        currentGroup: state.user && state.user.group ? state.user.group : null,
        selectedLayout: state.layouts.selectedLayout,
    };
};

export default connect(mapStateToProps)(AddOrder);
